import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import { Play, Expand } from '../icons/index'
import { BROWSER } from '../../browser-detect'
import './_video.scss'

class VideoPlayer extends Component {
  constructor() {
    super()
    this.state = {
      playing: false,
      isLoaded: false,
      shouldPlay: false,
      currentVideo: ''
    }
  }
  componentWillMount() {
    const { playVideo, video } = this.props
    this.setState({
      shouldPlay: playVideo,
      currentVideo: video.slug
    })
  }
  componentDidMount() {
    const { shouldPlay } = this.state
    const video = document.querySelector('.active_slide .inner .small_screen_video video')
    if (shouldPlay) {
      this.props.isLoaded(true)
      video.play()
      this.setState({
        isLoaded: true,
        playing: true
      })
    }
    video.addEventListener('ended', () => {
      if (video.ended) {
        this.props.videoHasEnded(true)
        console.log('The video has ended')
      }
    })
    video.addEventListener('loadeddata', () => {
      if (video.readyState >= 2) {
        this.props.isLoaded(true)
        video.play()
      }
    })
  }
  startVideo = () => {
    const _video = document.querySelector('.active_slide .inner .small_screen_video video')
    const fsUrlVid = this.reactPlayer.getInternalPlayer()
    fsUrlVid.addEventListener('loadeddata', () => {
        if (fsUrlVid.readyState >= 2) {
          fsUrlVid.play()
        }
      })
    if (_video) {
      _video.addEventListener('loadeddata', () => {
        if (_video.readyState >= 2) {
          this.props.isLoaded(true)
          _video.play()
        }
      })
    }
  }

  render() {
    return (
      <ReactPlayer
        onCanPlay={this.startVideo}
        url={this.props.video.url}
        className={`small_screen_video`}
        height="100%"
        width="100%"
        controls={true}
        ref={reactPlayer => (this.reactPlayer = reactPlayer)}
      />
    )
  }
}

export default class Video extends Component {
  constructor(props) {
    super(props)

    this.state = {
      videoCount: 0,
      activeVideo: 0,
      playThisVideo: null,
      appendText: false,
      loadVideo: false,
      fullScreen: false,
      playVideo: false
    }
  }

  componentDidMount() {
    const { activeIndex, videos, isNext, slideIndex } = this.props
    const nextSlide = document.querySelector(`.video_slide_${slideIndex}`)

    this.setNextVideo(activeIndex, slideIndex, nextSlide)
    this.setState({
      videoCount: videos.length,
      activeVideo: activeIndex,
      appendText: true
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { slideIndex, activeIndex, videos } = prevProps
    if (this.state.activeVideo !== this.props.activeIndex) {
      this.setState({
        activeVideo: this.props.activeIndex
      })
    }
  }

  setNextVideo = (active, slideIndex, nextSlide) => {
    if (slideIndex - active === 1) {
      nextSlide.classList.add('next_slide')
    }
  }

  isLoaded = isLoaded => {
    const { loadVideo, playThisVideo } = this.state
    const activeSlide = document.querySelector('.active_slide .video.not_loaded')
    if (isLoaded && activeSlide) {
      activeSlide.classList.remove('not_loaded')
      activeSlide.classList.add('loaded')
    }
  }

  hasEnded = videoOver => {

    if (videoOver) {
      this.props.videoHasEnded(true)
    }
  }

  loadVideoFile = () => {
    const { activeIndex, videos } = this.props
    const playThisVideo = videos[activeIndex]
    
    this.setState({
      loadVideo: true,
      playThisVideo: playThisVideo,
      playVideo: true
    })
    this.isLoaded(true)
  }

  removeActiveTitleCard = () => {
    this.loadVideoFile()
    const _this = this

    const { activeVideo } = this.state
    const textContent = document.querySelector('.active_slide .inner .text_content')
    const poster = document.getElementById(`video_poster_${activeVideo}`)
    if (BROWSER.isExplorer()) {
      textContent.classList.add('hidden')
      poster.classList.add('hidden')
    } else {
      textContent.classList.add('animated', 'slideOutLeft')
      poster.classList.add('animated', 'fadeOutLeft')
    }
  }

  handleFullScreenButton = () => {
    this.setState({
      playVideo: false,
      fullScreen: true,
      loadVideo: false,
      playThisVideo: null
    })
    this.props.launchFullScreen()
  }

  render() {
    const { activeVideo, videoCount, appendText, showModal, loadVideo, playThisVideo, playVideo } = this.state
    const { slideIndex } = this.props
    const _isActive = slideIndex === activeVideo ? 'active_slide' : ''
    const intimacy = (
      <span>
        The <b>Intimacy</b>
      </span>
    )
    const legacy = (
      <span>
        Builds <b className="Legacy">Legacy</b>
      </span>
    )

    const TextContent = (
      <div className="text_content">
        <h1 className={`animated fadeInUp ${this.props.video.title}`}>
          {this.props.video.title === 'The Intimacy' ? intimacy : this.props.video.title}
        </h1>
        <h2 className={`animated fadeInUp ${this.props.video.description}`}>
          {this.props.video.description === 'Builds Legacy' ? legacy : this.props.video.description}{' '}
        </h2>
        <h5 className="animated fadeInUp">
          <button className="playButton" onClick={this.removeActiveTitleCard}>
            <Play />
          </button>
        </h5>
      </div>
    )
    const TextContentHTML = appendText ? TextContent : null
    const FullScreenButton = (
      <span className="full_screen_button" onClick={this.handleFullScreenButton}>
        <Expand />
      </span>
    )

    const videoToPlay =
      loadVideo && playThisVideo ? (
        <VideoPlayer
          playVideo={playVideo}
          video={playThisVideo}
          fullScreen={this.state.fullScreen}
          videoHasEnded={this.hasEnded}
          isLoaded={this.isLoaded}
        />
      ) : null

    return (
      <div className={`video_slide video_slide_${slideIndex} ${_isActive}`}>
        <div className="inner">
          {TextContentHTML}
          <div className="video not_loaded">
            <img src={this.props.video.poster} id={`video_poster_${activeVideo}`} className="video_poster" />
            {videoToPlay}
            {FullScreenButton}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/video/index.js